import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { map } from 'rxjs/operators';
const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class RewardService {
  constructor(private http: HttpClient) { }
  getAll(query): any {
    return this.http.get<any[]>(API_URL + `rewards`, {params: query});
  }
  create(data): any{
    return this.http
    .post(API_URL + 'rewards', data)
      .pipe(map(res => {
        return res;
    }));
  }
  get(id): any {
    return this.http.get<any[]>(API_URL + `rewards/` + id);
  }
  search(keyword): any {
  return this.http.get<any[]>(API_URL + `rewards/search/` + keyword).pipe(map(res => {
    return res;
  }));
  }
  update(data, id): any{
    return this.http
    .put(API_URL + 'rewards/' + id , data)
      .pipe(map(res => {
        return res;
    }));
  }

  active(id): any{
  return this.http
  .put(API_URL + 'rewards/' + id + '/active/',null)
    .pipe(map(res => {
      return res;
  }));
}
inactive(id): any{
  return this.http
  .put(API_URL + 'rewards/' + id + '/inactive/', null)
    .pipe(map(res => {
      return res;
  }));
}

  changeStatus(id, status): any{
    return this.http
    .put(API_URL + 'rewards/' + id + '/' + status , null)
      .pipe(map(res => {
        return res;
    }));
  }

  changeStatusDelete(id, status): any{
    return this.http
    .delete(API_URL + 'rewards/' + id + '/' + status )
      .pipe(map(res => {
        return res;
    }));
  }

  delete(id): any{
    return this.http
    .delete(API_URL + 'rewards/' + id + '/delete')
      .pipe(map(res => {
        return res;
    }));
  }

  getAllTypesEnum(): any {
    return this.http.get<any[]>(API_URL + `reward-types/types`);
  }

  getAllTypes(query): any {
    return this.http.get<any[]>(API_URL + `reward-types`, {params: query});
  }
  createType(data): any{
    return this.http
    .post(API_URL + 'reward-types', data)
      .pipe(map(res => {
        return res;
    }));
  }
  getType(id): any {
    return this.http.get<any[]>(API_URL + `reward-types/` + id);
  }
  searchType(keyword): any {
  return this.http.get<any[]>(API_URL + `reward-types/search/` + keyword).pipe(map(res => {
    return res;
  }));
  }
  updateType(data, id): any{
    return this.http
    .put(API_URL + 'reward-types/' + id , data)
      .pipe(map(res => {
        return res;
    }));
  }

  activeType(id): any{
  return this.http
  .put(API_URL + 'reward-types/' + id + '/active/',null)
    .pipe(map(res => {
      return res;
  }));
}
inactiveType(id): any{
  return this.http
  .put(API_URL + 'reward-types/' + id + '/inactive/', null)
    .pipe(map(res => {
      return res;
  }));
}

  changeStatusType(id, status): any{
    return this.http
    .put(API_URL + 'reward-types/' + id + '/' + status , null)
      .pipe(map(res => {
        return res;
    }));
  }

  changeStatusDeleteType(id, status): any{
    return this.http
    .delete(API_URL + 'reward-types/' + id + '/' + status )
      .pipe(map(res => {
        return res;
    }));
  }

  deleteType(id): any{
    return this.http
    .delete(API_URL + 'reward-types/' + id + '/delete')
      .pipe(map(res => {
        return res;
    }));
  }
}
